<div class="tabs">
  <div class="tab" *ngIf="translationTool">
    <button (click)="tabs.active ='translation'" [ngClass]="{'active':tabs.active === 'translation'}">Translation</button>
  </div>
  <div class="tab" *ngIf="neighboursTool">
    <button (click)="tabs.active ='neighbours'" [ngClass]="{'active':tabs.active === 'neighbours'}">Neighbours</button>
  </div>
  <div class="tab" *ngIf="exceptionsTool">
    <button (click)="tabs.active ='exceptions'" [ngClass]="{'active':tabs.active === 'exceptions'}">Exceptions</button>
  </div>
</div>

<div class="tabs-content">
  <app-sbeditor-tool-translation *ngIf="translationTool" [hidden]="tabs.active !== 'translation'" #translation (exportTool)="getTool($event,'translation')"></app-sbeditor-tool-translation>
  <app-sbeditor-tool-neighbours *ngIf="neighboursTool" [hidden]="tabs.active !== 'neighbours'" #neighbours (exportTool)="getTool($event,'neighbours')"></app-sbeditor-tool-neighbours>
  <app-sbeditor-tool-exceptions *ngIf="exceptionsTool" [hidden]="tabs.active !== 'exceptions'" #exceptions (exportTool)="getTool($event,'exceptions')"></app-sbeditor-tool-exceptions>
</div>

<div class="tabs-bottom">
  <button class="btn-secondary-action m-auto" (click)="save()">Aplicar cambios</button>
</div>